<template>
    <div class="relative rounded-xl bg-surface-level-0 backdrop-blur-75">
        <AppButtonOption @click="openMenu" />
        <AppPopupMenu v-if="showMenu" :menuItems="menuItems" @close="handleClose" @click="handleClick" />
    </div>
</template>
<script setup lang="ts">
import { defineProps, defineEmits, ref } from "vue";
import { MenuItem } from "@/models/MenuItem";
import AppButtonOption from "./AppButtonOption.vue";
import AppPopupMenu from "./AppPopupMenu.vue";

interface Props {
    menuItems: MenuItem[];
}

defineProps<Props>();
const emit = defineEmits(["click"]);

const showMenu = ref(false);

const handleClose = () => {
    showMenu.value = false;
};

const openMenu = () => {
    showMenu.value = true;
};

const handleClick = (action: string) => {
    emit("click", action);
    showMenu.value = false;
};
</script>
